import { notification } from "../sounds";
import { useCallback } from "react";

export function useNotification() {

	const notify = useCallback(() => {
		try {
			const sound = new Audio(notification);
			sound.play();
		} catch (error) {
			console.warn(error.message);
		}
	}, []);

	return { notify }
}